import React, { useEffect, useState } from 'react'
import { message, Pagination } from 'antd'
import { getEmployeeFaq, deleteEmployeeFaq } from '../../../Web Apis/webApis'
import Load from '../../Load/Load'
import { AiFillDelete, AiFillEdit } from "react-icons/ai";
import CreateEmployeeFaq from './CreateEmployeeFaq';
import EditEmployeeFaq from './EditEmployeeFaq';

const EmployeeFaq = () => {
    const [allFaqs, setAllFaqs] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [loading, setLoading] = useState(false)
    const [showCreateFaq, setShowCreateFaq] = useState(false)
    const [showUpdateFaq, setShowUpdateFaq] = useState(false)
    const [showDeleteFaq, setShowDeleteFaq] = useState(false)
    const [action, setAction] = useState(false);
    const [selectedFaq, setSelectedFaq] = useState({})

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    // Calculate the current items for the page
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentFaqs = allFaqs.slice(indexOfFirstItem, indexOfLastItem);

    const getAllFaqs = async () => {
        try {
            setLoading(true)
            const response = await getEmployeeFaq();
            if (response?.data?.success) {
                const reverseData = [...response?.data?.data].reverse();
                setAllFaqs(reverseData)
            }
        } catch (error) {
             console.log("Error while getting faqs")
                           if (error.message === 'Network Error' || error.message.includes('ERR_INTERNET_DISCONNECTED')) {
                                message.error("Network Error")
                                return;
                              }
                              // Handle specific error cases
                              if (error?.response?.status === 401) {
                                window.alert("Your account is logged in to another device, please login again !")
                                localStorage.removeItem('token');
                                window.location.href = "/login";
                                
                              }
                              if (error?.response?.status === 500) {
                                message.error("Server not responding")
                                return;
                              } else {
                                return
                              }
        } finally {
            setLoading(false)
        }
    }

    const handleDeleteEmployeeFaqs = async () => {
        if (!selectedFaq) return;
        try {
            setLoading(true)
            const response = await deleteEmployeeFaq(selectedFaq.id)
            if (response?.data?.success) {
                message.success(response?.data?.message)
                setAction(!action);
                setShowDeleteFaq(false)
            }
        } catch (error) {
            console.log("Error while delete faq", error.message)
            message.error(error?.response?.data?.message || "Error while delete faq")
        } finally {
            setLoading(false)
        }
    }



    useEffect(() => {
        getAllFaqs();
    }, [action])

    const handleCreateModalOpen = () => {
        setShowCreateFaq(true)
    }

    const handleUpdateModalOpen = (faqs) => {
        setSelectedFaq(faqs)
        setShowUpdateFaq(true)
    }

    const handleDeleteFaqModalOpen = (faqs) => {
        setSelectedFaq(faqs)
        setShowDeleteFaq(true)
    }


    return (
        <div className='p-4 mt-16'>
            <div className="flex justify-between items-center w-full space-x-4">
                <h3 className='text-2xl text-gray-600 font-bold'>Frequently Asked Questions </h3>
                <button
                    onClick={handleCreateModalOpen}
                    className="bg-gradient-to-br from-teal-500 to-gray-500 hover:bg-blue-700 text-white font-bold py-2 px-8 rounded"
                >
                    Add More
                </button>
            </div>
            <div>
                <table className='min-w-full mt-7 bg-gradient-to-br from-teal-600 to-teal-200 border border-b-4 border-black table-fixed'>
                    <thead>
                        <tr>
                            <th className="py-2 px-2 border-b text-center w-1/12">S.No</th>
                            <th className="py-2 px-4 border-b text-center w-5/12">Questions</th>
                            <th className="py-2 px-4 border-b text-center w-5/12">Answers</th>
                            <th className="py-2 px-2 border-b text-center w-1/12">Action </th>
                        </tr>
                    </thead>
                    {currentFaqs?.length > 0 ? (
                        currentFaqs?.map((faqs, index) => (
                            <tr key={faqs.id}
                                className={`hover:bg-gray-200 text-center transition duration-200 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-300'}`}
                            >
                                <td className='py-2 px-2 border-b'>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                <td className='py-2 px-4 border-b break-words'>{faqs.question}</td>
                                <td className='py-2 px-4 border-b break-words'>{faqs.answer}</td>
                                <td className="py-2 px-4 border-b">
                                    <div className="flex flex-row justify-center">

                                        <button
                                            onClick={() => handleUpdateModalOpen(faqs)}
                                            className="mr-2 text-blue-500 hover:text-blue-700 flex items-center"
                                        >
                                            <AiFillEdit className="mr-1 text-xl" />
                                        </button>
                                        <button
                                            onClick={() => handleDeleteFaqModalOpen(faqs)}
                                            className="text-red-500 hover:text-red-700 flex items-center"
                                        >
                                            <AiFillDelete className="mr-1 text-xl" />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))
                    ) :
                        (
                            <tr>
                                <td colSpan="7" className=' px-4 py-4 border-b text-center font-bold'>No FAQ data found</td>
                            </tr>
                        )}
                    <tbody>

                    </tbody>
                </table>
                {loading && <Load />}
            </div>


            <div className="mt-4 flex justify-end">
                <Pagination
                    current={currentPage}
                    total={allFaqs.length}
                    pageSize={itemsPerPage}
                    onChange={handlePageChange}
                    showSizeChanger={false}
                />
            </div>

            {showCreateFaq && (
                <CreateEmployeeFaq
                    showCreateFaq={showCreateFaq}
                    setShowCreateFaq={setShowCreateFaq}
                    action={action}
                    setAction={setAction}
                />
            )}

            {showUpdateFaq && (
                <EditEmployeeFaq
                    showUpdateFaq={showUpdateFaq}
                    setShowUpdateFaq={setShowUpdateFaq}
                    selectedFaq={selectedFaq}
                    action={action}
                    setAction={setAction}
                />
            )}


            {showDeleteFaq && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
                        <h3 className="text-3xl font-bold mb-4 text-start">Confirm Delete</h3>
                        <p className="mb-4 text-start">Are you sure you want to delete this FAQ ? </p>
                        <div className="flex justify-end gap-4">
                            <button onClick={() => { setShowDeleteFaq(false) }} className="bg-gray-300 text-black py-3 px-8 rounded-md hover:bg-gray-400 transition duration-200">
                                Cancel
                            </button>
                            <button onClick={handleDeleteEmployeeFaqs} className="bg-red-600 text-white py-3 px-8 rounded-md mr-2 hover:bg-red-700 transition duration-200">
                                Delete
                            </button>
                        </div>
                    </div>
                    {loading && <Load />}
                </div>
            )}

        </div>
    )
}

export default EmployeeFaq